import {Component, ContentChildren, EventEmitter, HostBinding, Input, Output, QueryList} from "@angular/core";
import {FUIContentLayoutHeaderControlComponent} from "../header-control/content-layout-header-control.component";

@Component({
    selector: "fui-rows",
    styleUrls: ["./rows.component.scss"],
    templateUrl: "./rows.component.html"
})
export class FUIRowsComponent {
    @Input() i18nParams: any = {};
    @HostBinding("class.labelled") @Input() public label: string;
    @HostBinding("class.bordered") @Input() bordered: boolean;
    @HostBinding("class.switched") @Input() switched: boolean;
    @HostBinding("class.controlled") get controlled(): boolean {
        return !!this.headerControl;
    }
    @Output() enabledChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    @ContentChildren(FUIContentLayoutHeaderControlComponent, {descendants: false}) public headerControl: QueryList<FUIContentLayoutHeaderControlComponent>;

    private _enabled: boolean;

    @Input() get enabled(): boolean {
        return this._enabled;
    }

    set enabled(value: boolean) {
        this._enabled = value;
        this.enabledChange.emit(value);
    }
}
